<script lang="ts">
  import Button from '$components/reusable/Button.svelte';
  import DotGrid from '$components/reusable/DotGrid.svelte';
  import TextInput from '$components/reusable/TextInput.svelte';
  import HideEyeIcon from '$icons/HideEyeIcon.svelte';
  import ShowEyeIcon from '$icons/ShowEyeIcon.svelte';
  import { signupWithEmailAndPassword } from '$utils/auth/supertokens';
  import { defaults, setError, superForm } from 'sveltekit-superforms';
  import { zod } from 'sveltekit-superforms/adapters';
  import { signUpSchema } from '$shared/lib';
  import OAuthButtons from '$components/reusable/auth/OAuthButtons.svelte';
  import AuthContainer from '$lib/components/reusable/auth/AuthContainer.svelte';
  import UsernameInput from '$lib/components/reusable/UsernameInput.svelte';

  let showPassword = false;
  const signupForm = superForm(defaults(zod(signUpSchema)), {
    SPA: true,
    dataType: 'json',
    validators: zod(signUpSchema),
    validationMethod: 'onsubmit',
    onUpdate: async ({ form }) => {
      if (!form.valid) {
        return;
      }

      // Attempt to create the user in supertokens
      const fieldErrors = await signupWithEmailAndPassword(form.data);
      for (const [key, value] of Object.entries(fieldErrors)) {
        setError(form, key as keyof typeof form.data, value);
      }
    },
  });

  const { form, errors, enhance } = signupForm;

  function toggleShowPassword() {
    showPassword = !showPassword;
  }
</script>

<AuthContainer>
  <div
    class="items-left gap-x-md border-gray-dark-2 bg-gray-dark-1 px-lg py-md flex w-full flex-col border-b-2"
  >
    <div class="gap-x-md flex flex-row items-center">
      <h2 class="text-normal font-architekt text-gray-dark-12 text-lg leading-6">
        // CREATE YOUR ACCOUNT
      </h2>
      <DotGrid />
    </div>
  </div>
  <form
    method="POST"
    use:enhance
    on:submit|preventDefault
    class="px-2xl py-xl space-y-lg flex h-full w-full flex-col"
  >
    <div class="gap-lg flex flex-col items-start justify-between sm:flex-row">
      <UsernameInput
        placeholder="toly"
        bind:value={$form.username}
        bind:errors={$errors.username}
      />
      <TextInput
        label="Display Name"
        placeholder="Anatoly Yakovenko"
        bind:value={$form.displayName}
        bind:errors={$errors.displayName}
      />
    </div>
    <div class="gap-y-lg flex flex-col">
      <TextInput
        label="Email Address"
        placeholder="anatoly@solana.com"
        bind:value={$form.email}
        bind:errors={$errors.email}
      />
      <TextInput
        label="Password"
        type={showPassword ? 'text' : 'password'}
        bind:value={$form.password}
        bind:errors={$errors.password}
      >
        <button type="button" slot="right-icon" tabindex="-1" on:click={toggleShowPassword}>
          {#if showPassword}
            <HideEyeIcon />
          {:else}
            <ShowEyeIcon />
          {/if}
        </button>
      </TextInput>
      <div>
        <Button secondary class="!h-10 w-full" type="submit">Continue with email</Button>
        <p class="mt-md text-gray-dark-11 text-center text-xs font-semibold leading-5">
          Already have an account? <span class="text-gray-dark-12 underline"
            ><a href="/signin" data-sveltekit-preload-data>Login</a></span
          >
        </p>
      </div>
    </div>
    <OAuthButtons />
    <p class="text-gray-dark-11 py-2 text-center text-xs font-normal leading-4">
      By creating your account, you agree to the <span class="text-gray-dark-12 underline"
        ><a href="https://colosseum.org/legal/Colosseum%20-%20Terms%20of%20Service.pdf"
          >Terms of Service</a
        ></span
      >
      and
      <span class="text-gray-dark-12 underline"
        ><a href="https://colosseum.org/legal/Colosseum%20-%20Privacy%20Policy.pdf"
          >Privacy Policy</a
        ></span
      >.
    </p>
  </form>
</AuthContainer>
